import { render, staticRenderFns } from "./ChartDataProvider.vue?vue&type=template&id=315c0f98&scoped=true&"
import script from "./ChartDataProvider.vue?vue&type=script&lang=js&"
export * from "./ChartDataProvider.vue?vue&type=script&lang=js&"
import style0 from "./ChartDataProvider.vue?vue&type=style&index=0&id=315c0f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c0f98",
  null
  
)

export default component.exports